import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { TnbUser } from '../../../service/auth/tnb-user';
import { AuthenticationService } from '../../../service/auth/authentication.service';
import { ConfirmDialogService } from '../../../service/common/confirm-dialog/confirm-dialog.service';
import { ImportWizardDialogService } from '../../../ea-import-wizard/service/import-wizard-dialog.service';
import { Observable } from 'rxjs';
import { ErzeugungsanlageExportService } from '../../../service/erzeugungsanlage/erzeugungsanlage-export.service';
import { ImportWizardComponent } from '../../../ea-import-wizard/import-wizard/import-wizard.component';
import { tap } from 'rxjs/operators';
import { NetzbetreiberTeilgebieteInfo } from '../../../service/auth/netzbetreiber-teilgebiete-info';
import { TeilgebietSelectionService } from '../../../service/common/teilgebiet/teilgebiet-selection.service';

@Component({
    selector: 'tnb-navigation-header',
    templateUrl: './navigation-header.component.html',
    styleUrls: [
        './navigation-header.component.scss',
    ],
    standalone: false,
})
export class NavigationHeaderComponent implements OnInit {
    authenticationService = inject(AuthenticationService);
    importWizardDialogService = inject(ImportWizardDialogService);
    private confirmDialogService = inject(ConfirmDialogService);
    private erzeugungsanlageExportService = inject(ErzeugungsanlageExportService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public user$: Observable<TnbUser> = null;
    public selectedTeilgebiet: NetzbetreiberTeilgebieteInfo | undefined;

    public wizardComponent = ImportWizardComponent;

    async ngOnInit() {
        this.user$ = this.authenticationService.user$.pipe(
            tap((_) => {
                this.selectedTeilgebiet = this.teilgebietSelectionService.getSelectedTeilgebiet();
            }),
        );
    }

    public login() {
        this.authenticationService.login();
    }

    public async logout() {
        if (await this.confirmDialogService.confirm(
            'Möchten Sie sich wirklich ausloggen?', 'Ausloggen?',
            'primary', 'Ja', 'Nein')) {
            this.teilgebietSelectionService.resetSelection();
            this.authenticationService.logout();
        }
    }

    public async selectTeilgebiet(teilgebiet: NetzbetreiberTeilgebieteInfo) {
        if (await this.confirmDialogService.confirm(
            `Möchten Sie wirklich das Teilgebiet '${teilgebiet.teilgebiet}' auswählen?`,
            'Teilgebietsauswahl',
            'primary',
            'Ja',
            'Nein',
            'innogy_picto_double-arrow',
        )
        ) {
            this.teilgebietSelectionService.setSelectedTeilgebiet(teilgebiet);
            this.selectedTeilgebiet = teilgebiet;
            this.changeDetectorRef.markForCheck();
            window.location.reload();        
        }
    }

    public isTeilgebietSelected(teilgebiet: NetzbetreiberTeilgebieteInfo): boolean {
        return this.isSameTeilgebiet(teilgebiet, this.selectedTeilgebiet);
    }

    public isSameTeilgebiet(tgb1: NetzbetreiberTeilgebieteInfo | null, tgb2: NetzbetreiberTeilgebieteInfo | null): boolean {
        return tgb1?.stadtwerkeId === tgb2?.stadtwerkeId;
    }

    public export() {
        const teilgebiet = this.teilgebietSelectionService.getSelectedTeilgebiet();
        this.erzeugungsanlageExportService.exportErzeugungsanlagen(
            teilgebiet.stadtwerkeId,
            teilgebiet.teilgebiet,
        );
    }

    shouldSeeErzeugungsanlagenFeatureWestnetzAlways(profile: TnbUser): boolean {
        // should be visible for westnetz always, for nvnb only if summenErzeuger && erzeugungsAnlagenPflegeAktiv
        return (profile.netzbetreiberType === 'WESTNETZ' || this.selectedTeilgebiet?.erzeugungsAnlagenPflegeAktiv);
    }

    shouldSeeErzeugungsanlagenFeatureOnlyStadtwerk(profile: TnbUser): boolean {
        // only visible to nvnb if  erzeugungsAnlagenPflegeAktiv
        return profile.netzbetreiberType === 'STADTWERK' && (this.selectedTeilgebiet?.erzeugungsAnlagenPflegeAktiv);
    }
}
